import type { State } from 'state';
import type { SignUpState } from 'state/persisted/sign-up';

export const getSignUpState = (state: State): SignUpState => {
    return state.persisted.signUp;
};
